import { NavLink } from "react-router-dom";
import { Home, Calendar, Newspaper, CheckSquare, KeyRound, BookOpen } from "lucide-react";

const items = [
  { to: "/", label: "Hem", icon: Home, testid: "nav-home" },
  { to: "/vad-ar-nytt", label: "Nytt", icon: Newspaper, testid: "nav-whats-new" },
  { to: "/laxor", label: "Läxor", icon: BookOpen, testid: "nav-homework" },
  { to: "/kalender", label: "Kalender", icon: Calendar, testid: "nav-calendar" },
  { to: "/att-gora", label: "Att-göra", icon: CheckSquare, testid: "nav-todos" },
  { to: "/koder", label: "Koder", icon: KeyRound, testid: "nav-vault" },
];

export default function BottomNav() {
  return (
    <nav
      className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md md:max-w-lg z-40 bottom-nav"
      data-testid="bottom-navigation"
    >
      <div className="mx-3 mb-1 rounded-2xl backdrop-blur-xl bg-white/85 border border-[color:var(--border-subtle)] shadow-[0_1px_0_rgba(0,0,0,0.02)]">
        <ul className="grid grid-cols-6 gap-0.5 px-1.5 py-2">
          {items.map(({ to, label, icon: Icon, testid }) => (
            <li key={to}>
              <NavLink
                to={to}
                end={to === "/"}
                data-testid={testid}
                className={({ isActive }) =>
                  `flex flex-col items-center justify-center gap-1 py-2 px-0.5 rounded-xl transition-colors duration-200 ${
                    isActive
                      ? "text-[color:var(--moss)] bg-[color:var(--bg-elevated)]"
                      : "text-[color:var(--text-tertiary)] hover:text-[color:var(--text-secondary)]"
                  }`
                }
              >
                <Icon size={19} strokeWidth={1.8} />
                <span className="text-[9.5px] font-medium tracking-tight">{label}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}
